import { IStaff } from "../types/interfaces/IStaff";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const NEONATOLOGIST = "neonatologist";

//This function create data for each staff.
function createData(staffId: string, role: string, name: string, phone: string, email: string) {
    return { staffId, role, name, phone, email };
}

//This function creates a list of staffs with detailed info.
export default function NicuStaffDetail(props: {staffs: Array<IStaff>}) {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.white,
          fontWeight:"bold",
          color:'#00247F',
          fontSize:"20px",
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 16,
          border: 0
        },
      }));
      
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: '#ECEFF1',
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const rows = props.staffs.filter(staff => staff.RoleName?.toLowerCase() != NEONATOLOGIST)
        .map(staff => { return createData(staff.StaffId!, staff.RoleName==null?"":staff.RoleName, staff.FullName==null?"":staff.FullName, staff.Phone==null?"":staff.Phone, staff.Email==null?"":staff.Email)
        }).sort((a, b) => {
            if(a.role.toLowerCase() < b.role.toLowerCase()) {
                return -1;
            }
            else if(a.role.toLowerCase() == b.role.toLowerCase()) {
                return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
            }
            else {
                return 1;
            }
    });
        
    const neonatologistRows = props.staffs.filter(staff => staff.RoleName?.toLowerCase() == NEONATOLOGIST)
    .sort((a, b) => (a.FullName!.toLowerCase() < b.FullName!.toLowerCase() ? -1 : 1))
    .map(staff => { return createData(staff.StaffId!, staff.RoleName==null?"":staff.RoleName, staff.FullName==null?"":staff.FullName, staff.Phone==null?"":staff.Phone, staff.Email==null?"":staff.Email)});

    if(neonatologistRows.length > 0)
    {
        neonatologistRows.forEach((item) => { rows.push(item); });
    }

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 320 }}>
            <Table sx={{ minWidth: 700 }} aria-label="staff table" stickyHeader>
                <TableHead sx={{border: 0}}>
                <TableRow>
                    <StyledTableCell>Role</StyledTableCell>
                    <StyledTableCell align="right">Full Name</StyledTableCell>
                    <StyledTableCell align="right">Phone</StyledTableCell>
                    <StyledTableCell align="right">Email</StyledTableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {rows.map((row) => (
                    <StyledTableRow key={row.staffId}>
                    <StyledTableCell component="th" scope="row">{row.role}</StyledTableCell>
                    <StyledTableCell align="right">{row.name}</StyledTableCell>
                    <StyledTableCell align="right">{row.phone}</StyledTableCell>
                    <StyledTableCell align="right">{row.email}</StyledTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}